/** The available tabs for the settings takeover */
export enum SettingsTab {
  /** View information about the Journey and set the description */
  About = 'about',
  /** Set the metrics to be shown in the send tiles */
  Metrics = 'metrics',
  /** Set the metrics and conversions to be shown in the send tiles */
  ConversionsAndMetrics = 'conversion-and-metrics',
  /** Set the exit rules for the journey */
  ExitRules = 'exit-rules',
}

/** The test IDs for the settings takeover */
export enum SettingsTakeoverTestId {
  /** The about tab element */
  AboutTab = 'about-tab',
  /** The metrics tab element */
  MetricsTab = 'metrics-tab', // will continue to use this for the both metrics and conversions with and without feature flag
  /** The exit rules tab element */
  ExitRulesTab = 'exit-rules-tab',
}

export const DESCRIPTION_FIELD = 'description';
export const NAME_FIELD = 'name';
export const LABELS_FIELD = 'labelIds';
